import styled from 'styled-components/native';

import { white } from '../../../../constants/color';

export const PADDING_HORIZONTAL = 12;
export const MARGIN_HORIZONTAL = 16;

export const HEAD_HEIGHT = 20;
export const CONTAINER_PADDING_BOTTOM = 20;
export const BACKGROUND_PADDING_VERTICAL = 8;
export const BODY_MARGIN_TOP = 7;

export default {
  Container: styled.View<{ height: number }>`
    height: ${({ height }) => height}px;
    padding: 0 0 ${CONTAINER_PADDING_BOTTOM}px;
    margin: 0 ${MARGIN_HORIZONTAL}px;
  `,
  Background: styled.View`
    height: 100%;
    padding: ${BACKGROUND_PADDING_VERTICAL}px ${PADDING_HORIZONTAL}px;
    background-color: ${white};
  `,
  Head: styled.View`
    height: ${HEAD_HEIGHT}px;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
  `,
  Body: styled.View`
    flex: 1;
    margin-top: ${BODY_MARGIN_TOP}px;
    flex-direction: row;
    justify-content: space-between;
  `,
};
